export const personalizeProduct = {
  name: 'Personalize',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Optimize every experience across every channel with a next-gen experimentation and personalization platform.​',
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/c3477197ba1446a484cb91fb20c96905',
  },
  color: 'red',
  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          resource: 'tenant',
          jsonPath: '$.annotations.URL',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
};
